import type { ReactNode } from 'react'
import { Navbar } from './Navbar'

// Variant A on V2: navy top navbar + a centered content column, replacing
// the old sidebar layout. Width matches the approved mockup's `.container`
// (max-width 1080px, 28px/32px/48px top/side/bottom padding — Tailwind's
// pt-7/px-8/pb-12 are exact matches for those, not approximations).
export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <main className="mx-auto w-full min-w-0 max-w-[1080px] flex-1 px-8 pt-7 pb-12">{children}</main>
    </div>
  )
}
